import { useMemo } from "react";
import { useFilterList as useCoreFilterList } from "@b2bportal/core-cars";
import { usePackageCarsAvailabilityFilters } from "../../hooks";

/**
 * Hook for package car filters that uses incremental pricing
 */
export const usePackageCarFilters = () => {
  // Get the core filter list structure (for handlers like handleCarTypeFilter, etc.)
  const coreProps = useCoreFilterList();

  // Get package-specific context and handlers
  const { context, handlers } = usePackageCarsAvailabilityFilters();

  // Create custom reset filter handlers that use package-specific logic
  const resetFilter = useMemo(() => {
    return {
      resetCancellation: () => handlers.resetCancellationFilter(),
      resetCarTypeFilter: () => handlers.resetCarTypeFilter(),
      resetMinimumBagsFilter: () => handlers.resetMinimumBagsFilter(),
      resetPassengerFilter: () => handlers.resetPassengerFilter(),
      resetPriceFilter: () => handlers.resetPriceFilter(), // Package-specific reset
      resetSupplierFilter: () => handlers.resetSupplierFilter(),
    };
  }, [handlers]);

  return useMemo(
    () => ({
      context: {
        ...coreProps.context,
        // Override with package-specific filter options
        filterOptions: context.filterOptions,
      },
      handlers: {
        ...coreProps.handlers,
        resetFilter,
      },
    }),
    [coreProps, context.filterOptions, resetFilter]
  );
};
